// §4.4 partial — admin/admins routes.
// Composer auto-collects this into routes.generated.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminsPage = lazyWithRetry(() => import("./pages/AdminsPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [{ path: "/admin/admins", Component: AdminsPage }],
  },
];

export default routes;
